import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Popover, Table } from "antd";
import {
  useGetMyTaskExecutionsCountQuery,
  useGetMyTaskExecutionsQuery,
} from "shared/api";
import { buildMyTaskExecutionRows } from "shared/helpers";
import { useMyTaskExecutionsColumns } from "shared/hooks";
import { Routes } from "shared/routers";
import { MyTaskExecutionRow } from "shared/types";

export const MaintenanceWidget = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const columns = useMyTaskExecutionsColumns();

  const goToMyTasks = () => {
    setOpen(false);
    navigate(Routes.taskHubUserCompleteTasks.url);
  };

  const themeColor = JSON.parse(
    localStorage.getItem("color-theme") || '"#002F5F"'
  );

  const { data: countData } = useGetMyTaskExecutionsCountQuery();
  const count = countData?.count_my_task_executions ?? 0;

  // Only fetch the (heavier) tree while the dropdown is open.
  const { data: summaryData, isFetching } = useGetMyTaskExecutionsQuery(
    undefined,
    { skip: !open }
  );

  // Render the root's children directly: the virtual root (name === null) holds
  // top-level tasks in `task_executions` and named sections in `subsections`.
  const rows = useMemo<MyTaskExecutionRow[]>(() => {
    const root = summaryData?.my_task_executions;
    return root ? buildMyTaskExecutionRows(root) : [];
  }, [summaryData]);

  const content = (
    <div className="w-[1200px] max-w-[96vw]">
      <div className="max-h-[70vh] overflow-y-auto">
        <Table<MyTaskExecutionRow>
          size="small"
          columns={columns}
          dataSource={rows}
          loading={isFetching}
          pagination={false}
          expandable={{ defaultExpandAllRows: true }}
        />
      </div>

      <div className="mt-3 flex justify-end">
        <Button
          type="primary"
          style={{ backgroundColor: themeColor, borderColor: themeColor }}
          onClick={goToMyTasks}
        >
          Go to my tasks
        </Button>
      </div>
    </div>
  );

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      open={open}
      onOpenChange={setOpen}
      content={content}
    >
      <div
        className="cursor-pointer relative flex items-center justify-center"
        role="button"
        tabIndex={0}
      >
        {count > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-[6px] text-xs bg-red-600 text-white rounded-full flex items-center justify-center leading-none z-10 border border-white">
            {count > 99 ? "99+" : count}
          </span>
        )}

        <img
          width={70}
          height={70}
          className="object-contain hover:opacity-80 transition-opacity"
          src="/product-card-maintance-icon.png"
          alt="Maintenance"
        />
      </div>
    </Popover>
  );
};
